<script>
    import LoadingSpinner from './LoadingSpinner.svelte';

    export let pageLoading;
</script>

{#if pageLoading}
    <div class="fixed inset-0 z-50 flex items-center justify-center">
        <!-- Semi-transparent background -->
        <div class="absolute inset-0 bg-gray-800 opacity-100"></div>

        <!-- Modal content -->
        <div class="relative w-[200px] flex flex-col justify-between rounded-3xl bg-slate-50 p-8 text-slate-900 ring-1 ring-slate-300 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-300/20 xl:p-10 z-10 overflow-y-auto ">

            <div class="absolute left-[calc(50%-4rem)] -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)] top-10" aria-hidden="true"><div class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-20" style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%);"></div></div>
            <div class="text-gray-400">
                <LoadingSpinner message="Loading page" />
            </div>
        </div>
    </div>
{/if}

